import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import Android from "./android";
import Apple from "./apple";
import Windows from "./windows";
import Web from "./web";
import useTheme from "../../hooks/useTheme";
import { PlatformType, SupportedType } from "../../types/types";

export default function Platform(props: {
  platforms: SupportedType[];
  style?: React.CSSProperties;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const theme = useTheme();

  const styles: {
    platformStyle: React.CSSProperties;
  } = {
    platformStyle: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 4px 0px 4px",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        paddingTop: isSmallLayout || isMediumLayout ? 2 : 0,
        paddingBottom: isSmallLayout || isMediumLayout ? 2 : 0,
        ...props.style,
      }}
    >
      {props.platforms.map((item: SupportedType) => {
        return (
          <div
            key={item.platform}
            style={{
              textDecoration: "none",
              color: theme.textColor,
              fontSize: isSmallLayout ? 14 : 16,
              textAlign: "center",
            }}
          >
            {item.platform === PlatformType.android && (
              <Android
                minVersion={item?.minVersion}
                style={styles.platformStyle}
              />
            )}
            {item.platform === PlatformType.iOS && (
              <Apple
                minVersion={item?.minVersion}
                style={styles.platformStyle}
              />
            )}
            {item.platform === PlatformType.windows && (
              <Windows style={styles.platformStyle && { margin: 2 }} />
            )}
            {item.platform === PlatformType.web && (
              <Web style={styles.platformStyle && { margin: 2 }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
